import React from "react";
import { valid } from "node-html-parser";
import { useHtml } from "../../globals/HtmlContext";

export default function Window() {
  const html = useHtml();

  return (
    <iframe
      style={{
        boxSizing: "border-box",
        height: "80vh",
        width: "90%",
        border: "1px solid black",
        margin: "10px",
        borderRadius: "5px",
        padding: "10px",
        backgroundColor: "white",
      }}
      srcDoc={html}
      id="target"
    />
  );
}
